module.exports = __webpack_public_path__ + "img/crypto_four.124e546a.jpeg";